import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import {FaSignOutAlt, FaUser} from 'react-icons/fa';
import Style from 'styled-components';

import FollowLogo from '../../assets/images/follow.png';
import './styles.css';
import api from "../../services/api";

const BackgroundHeader = Style.div`
  background-color: #52648d;
  height: 10px;
  padding:0;
  margin: 0;
`;

const HeaderDiv = Style.div`
  height: 100px;
  padding:0;
  margin: 0;
`;

export default function Header(props){
    let id_company = localStorage.getItem('followize_id_company');
    let id_contact = localStorage.getItem('followize_id_contact');
    let id_user = localStorage.getItem('followize_id_user');

    const history = useHistory();

    const logout = async()=> {
        const response = await api.post('/email/delete?id_company=' + id_company + '&id_contact=' + id_contact + '&id_user=' + id_user);
        if(response.data){
            history.push('/?id_company=' + id_company + '&id_contact=' + id_contact + '&id_user=' + id_user);
        }
    }


    return(
        <>
        <HeaderDiv className="header">
          <div className="logoPipeHeader">
            <img id="domLogo" src={FollowLogo} alt="Followize Logo" />
          </div>

            <div className="deslogarUser">
                <a
                    onClick={() => { if (window.confirm('Deseja sair desse usuário?')) logout() } }
                >
                    <FaSignOutAlt id="iconSair"/>
                </a>
            </div>

          <div className="textHeader">
            <p>{props.title}</p>
          </div>
        </HeaderDiv>
        </>
    )
}